export default {
  slug: "jetbrains-game-dev",
  code: "GDV",
  label: "JetBrains Game Dev",
  hideProductName: true,
  krakenDir: "Game Dev",
  logoFamily: "gamedev",
};
